import { render } from "./ModalAdicionarTarefa.vue?vue&type=template&id=22fb3b0d"
import script from "./ModalAdicionarTarefa.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarTarefa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__